var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLovedSurprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM5.32337 6.94831C4.38286 7.19317 3.81499 8.09719 4.055 8.96749C4.56798 10.8276 6.23893 11.5646 7.56629 11.9333C8.20185 12.1098 8.89255 11.9299 9.35212 11.4683C10.3119 10.5042 11.3798 9.05421 10.8668 7.19408C10.6268 6.32378 9.66978 5.81675 8.72927 6.06161C7.9054 6.2761 7.3334 7.00526 7.37398 7.76562C7.01783 7.08742 6.14724 6.73382 5.32337 6.94831ZM19.945 8.96749C20.185 8.09719 19.6171 7.19317 18.6766 6.94831C17.8528 6.73382 16.9822 7.08742 16.626 7.76562C16.6666 7.00526 16.0946 6.2761 15.2707 6.06161C14.3302 5.81675 13.3732 6.32378 13.1332 7.19408C12.6202 9.05421 13.6881 10.5042 14.6479 11.4683C15.1075 11.9299 15.7981 12.1098 16.4337 11.9333C17.7611 11.5646 19.432 10.8276 19.945 8.96749ZM12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovedSurprise);
export default __webpack_public_path__ + "static/media/loved-surprise.3df88a0bbefbc86394b691b16f45a6dd.svg";
export { ForwardRef as ReactComponent };